module.exports = __webpack_public_path__ + "static/img/bg-9.1695021f.jpg";